import { render, staticRenderFns } from "./RightRevisitRate.vue?vue&type=template&id=1ec1d518&scoped=true"
import script from "./RightRevisitRate.vue?vue&type=script&lang=js"
export * from "./RightRevisitRate.vue?vue&type=script&lang=js"
import style0 from "./RightRevisitRate.vue?vue&type=style&index=0&id=1ec1d518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec1d518",
  null
  
)

export default component.exports